<template>
<div class="chapter">
<div class="inner_page">
<section role="doc-toc">
<h1 class="ack"><span aria-label="ix" id="page_ix" role="doc-pagebreak">CONTENTS</span></h1>
<nav epub:type="toc" id="toc" role="doc-toc">
<ol style="list-style-type:none">
<li class="textStyle2b center"><span href="#/Text/Cover" title="Link target outside of Sample">Cover</span></li>
<li class="textStyle2b center"><span href="#/Text/TitlePage#title" title="Link target outside of Sample">Title Page</span></li>
<li class="textStyle2b center"><span href="#/Text/Dedication" title="Link target outside of Sample">Dedication</span></li>
<li class="textStyle2b center"><a href="#/Text/nav">CONTENTS</a></li>
<li class="textStyle2b center" id="link2"><a href="#/Text/Introduction">INTRODUCTION<br/> by Peter Quinn</a></li>
<li class="textStyle2b center" id="link3"><a href="#/Text/Part01">PART ONE<br/> To the Manor Borne</a></li>
<li class="textStyle2b center" id="link4"><span href="#/Text/Part02" title="Link target outside of Sample">PART TWO<br/> Malachy Ascending</span></li>
<li class="textStyle2b center" id="link5"><span href="#/Text/Part03" title="Link target outside of Sample">PART THREE<br/> Dubious Luxuries</span></li>
<li class="textStyle2b center" id="link6"><span href="#/Text/Part04" title="Link target outside of Sample">PART FOUR<br/> Whirled Affairs</span></li>
<li class="textStyle2b center" id="link7"><span href="#/Text/Part05" title="Link target outside of Sample">PART FIVE<br/> Father to the Man</span></li>
<li class="textStyle2b center" id="link8"><span href="#/Text/Afterword" title="Link target outside of Sample">AFTERWORD</span></li>
<li class="textStyle2b center" id="link1"><span href="#/Text/Acknowledgments" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></li>
<li class="textStyle2b center" id="link9"><span href="#/Text/AboutAuthor" title="Link target outside of Sample">About the Author</span></li>
<li class="textStyle2b center"><span href="#/Text/Copyright" title="Link target outside of Sample">Copyright</span></li>
</ol>
</nav>
<div><span aria-label="x" id="page_x" role="doc-pagebreak"></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?2aca3799